import React, { useState, useEffect } from "react";
import { Col, Container, Modal, Row, Form, Button, ModalFooter } from 'react-bootstrap';
import '../../assets/Styles/DispatchCSS/DispatchCSS.css';
import GroupUnGroup from "./GroupingActions/GroupUnGroup";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css'; // Import Typeahead CSS
import { HotKeys } from "react-hotkeys";

const GroupingActions = (props) => {

    const [showGroupActionCreate, setGroupActionCreate] = useState(false);
    const [showGroupActionUpdate, setGroupActionUpdate] = useState(false);
    const [showGroupActionUngroup, setGroupActionUngroup] = useState(false);
    const [createGroupFlag, setCreateGroupFlag] = useState(1);
    const [UngroupFlag, setUngroupFlag] = useState(false);
    const [groupOptions, setGroupOptions] = useState([]); // User's input text
    const [selectedItem, setSelectedItem] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [selectedGroup, setSelectedGroup] = useState("-1");
    const [isChecked, setIsChecked] = useState(false);
    const [NoOfGroup, setNoOfGroup] = useState(-1);
    useEffect(() => {
        // let groupOptions = [];
        // const set = new Set();
        // if (props.GridRowData !== undefined) {
        //     props.GridRowData.forEach((data) => {
        //         if (data.Group && !set.has(data.Group)) {
        //             set.add(data.Group);
        //             groupOptions.push({ "label": data.Group, "value": data.Group });
        //         }
        //     });
        // }
        // if (groupOptions.length > 0) {
        //     setgroupFilterMultiSelect({ ...groupFilterMultiSelect, options: groupOptions });
        // }
        const distinctGroup = [...new Set(props.GridRowData
            .map(data => data.Group)
            .filter(Group => Group)
          )];
        setNoOfGroup(distinctGroup.length);
        const uniqueGroups = [...new Set(props.groupingSet.map(data => data.Group).filter(Boolean))];
        setGroupOptions(uniqueGroups);
        if(distinctGroup.length === 0)
        {
            setUngroupFlag(true);
        }
    }, []);
    const keyMap = {
        ALT_G: 'alt+g',
        ALT_U: 'alt+u'
    };
    const handleHotKeys = {
        ALT_G: () => {
            // console.log("ALT_G");
            handleGroupActionCreate();
        },
        ALT_U: () =>{
            // console.log("ALT_U");
            handleGroupActionUngroup();
        }
    };
    const handleCloseGroupingActionsDialog = () => {
        if (props.showGroupingDialog) {
            props.setShowGroupingActionDialog(false);
        }
    }

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const handleGroupActionCreate = () => {
        setGroupActionCreate(true);
    }

    const handleGroupActionUpdate = () => {
        setGroupActionUpdate(true);
    }

    const handleGroupActionUngroup = () => {
        setGroupActionUngroup(true);
    }

    const handleInputChange = (text) => {
        setSelectedGroup(text);
    };

    const handleSearch = (query) => {
        const matchingResults = groupOptions.filter((item) =>
            item.toLowerCase().includes(query.toLowerCase())
        );

        return matchingResults;
    };

    return (
        <>
        <HotKeys keyMap={keyMap} handlers={handleHotKeys}>
            <Modal show={props.showGroupingDialog ? 1 : 0} centered onHide={handleCloseGroupingActionsDialog} backdrop="static" keyboard={true} size="lg"
                aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton style={{ backgroundColor: "#32728B", color: '#fff' }}>
                    <Modal.Title className="user-select-none" id="contained-modal-title-vcenter">
                        Group/UnGroup Trips
                    </Modal.Title>
                </Modal.Header>
                {props.GridRowData.length > 0 ? 
                    <>
                        <Modal.Body className="p-0 user-select-none">
                            <Container className="mt-1">
                                <Row>
                                    <Col xs={6}>
                                        <span>FOR TRIP : <b className="mx-2">{props.GridRowData.length > 1 ? props.GridRowData.length + " trips selected" : props.GridRowData[0]["ConfirmationNo"]}</b></span>
                                    </Col>
                                    <Col xs={6}>
                                        <span> Number of Groups : <b className="mx-2">{NoOfGroup}</b></span>
                                    </Col>
                                </Row>
                                <Row className="tripaction_btn_seperator"></Row>
                                <Row>
                                    <Col xs={6}>
                                        <input type="radio" name={"GroupingRadioBtn"} value={2} checked={createGroupFlag === 2} onChange={(e)=>{setCreateGroupFlag(parseInt(e.target.value))}}/><p className="m-0 d-inline-flex mx-2 user-select-none">Add to Existing Group</p>
                                    </Col>
                                    <Col xs={6}>
                                        <input type="radio" name={"GroupingRadioBtn"} value={1} checked={createGroupFlag === 1} onChange={(e)=>{setCreateGroupFlag(parseInt(e.target.value))}}/><p className="m-0 d-inline-flex mx-2 user-select-none">Create New Group</p>
                                    </Col>
                                    {createGroupFlag === 2?
                                    <>
                                        <Col xs={6} className="mt-1">
                                            <Typeahead
                                                className="w-100"
                                                id="searchInput"
                                                labelKey={(option) => option}
                                                placeholder="Add/Search Group..."
                                                onChange={(selected) => {
                                                    setSelectedItem(selected);
                                                    setSelectedGroup(selected[0] || ''); // Update input value with the selected item
                                                }}
                                                onInputChange={handleInputChange}
                                                options={handleSearch(inputValue)}
                                                selected={selectedItem}
                                            />
                                        </Col>

                                        
                                    </>
                                    :
                                    <>
                                        <Col xs={6} className="mt-1">
                                            <input 
                                                onChange={(e) => {
                                                    setSelectedGroup(e.target.value || '');
                                                }} 
                                                className="w-100 border rounded py-2 px-3" 
                                                placeholder="New Group Name..."
                                            />
                                        </Col>
                                        <Col xs={6} className="mt-1">
                                            <Form style={{ marginTop: "2%" }}><Form.Check type="checkbox" id="chkOptionalGrouping" onClick={handleCheckboxChange} label="Optional" /></Form>
                                        </Col>
                                    </>
                                    
                                    }
                                </Row>
                            </Container>
                            <ModalFooter className="mt-2">
                                
                                <Button variant="dark" onClick={createGroupFlag === 2? handleGroupActionUpdate:handleGroupActionCreate} value={createGroupFlag === 2?"Update":"Create New"}>{createGroupFlag === 2? "Add to Existing":"Create Group"}</Button>
                                {/* <Button variant="dark" className="groupaction_btn" onClick={} value="Update">Update</Button> */}
                                <Button variant="dark" onClick={handleGroupActionUngroup} disabled={UngroupFlag} value="UnGroup">UnGroup</Button>
                                <Button variant="dark" onClick={handleCloseGroupingActionsDialog} value="Cancel">Cancel</Button>
                                
                            </ModalFooter>
                        </Modal.Body>
                    
                    </>:
                        <>
                            <Modal.Body className="user-select-none fw-bold">{"Please select a trip first before grouping action."}</Modal.Body>
                            <Modal.Footer>
                            
                                <Button variant="dark" onClick={()=>{props.setShowGroupingActionDialog(false)}}>OK</Button>
                            
                            </Modal.Footer>
                        </>
                    }
                
            </Modal>

            {showGroupActionCreate ? <GroupUnGroup GridRefresh={props.GridRefresh} GridRowData={props.GridRowData} showGroupActionCreate={showGroupActionCreate} setGroupActionCreate={setGroupActionCreate} setSelectedGroup={selectedGroup} isChecked={isChecked} /> : ""}
            {showGroupActionUpdate ? <GroupUnGroup GridRefresh={props.GridRefresh} GridRowData={props.GridRowData} showGroupActionUpdate={showGroupActionUpdate} setGroupActionUpdate={setGroupActionUpdate} setSelectedGroup={selectedGroup} isChecked={isChecked} /> : ""}
            {showGroupActionUngroup ? <GroupUnGroup GridRefresh={props.GridRefresh} GridRowData={props.GridRowData} showGroupActionUngroup={showGroupActionUngroup} setGroupActionUngroup={setGroupActionUngroup} setSelectedGroup={selectedGroup} isChecked={isChecked} /> : ""}
        </HotKeys>
        </>
    );
}

export default GroupingActions;